import { CalendarIcon, EllipseFilledIcon, EllipseHalfIcon } from '@bi-digital/icons';
import { Chip } from '@bi-digital/react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import type { ApplyItem, Arrangement, Term } from '../../../types';
import styles from './ShowOnlyFilter.module.css';
import { compareTerms } from '../../../utils';

export interface ShowOnlyFilterProps {
    items: ApplyItem[];
    selectedTerm: Term | null;
    selectedLoad: Arrangement['load'] | null;
    onSelectTerm: (value: Term) => void;
    onSelectLoad: (value: Arrangement['load']) => void;
    className?: string;
}

export function ShowOnlyFilter({
    items,
    selectedTerm,
    selectedLoad,
    onSelectTerm,
    onSelectLoad,
    className,
}: ShowOnlyFilterProps) {
    const { t } = useTranslation();
    const termFilters: Term[] = [...new Set(items.map(({ term }) => JSON.stringify(term)))].map((term) =>
        JSON.parse(term),
    );
    const loadFilters = [...new Set(items.map(({ load }) => load))];

    if (termFilters.length < 2 && loadFilters.length < 2) {
        return null;
    }

    return (
        <div className={classNames(styles.showOnlyFilter, className)}>
            <p>{t('cart:showOnly')}: </p>

            <div className={styles.chipsContainer}>
                {termFilters.length > 1 &&
                    termFilters.map((term, i) => (
                        <Chip
                            startIcon={<CalendarIcon aria-hidden='true' />}
                            className={styles.filterChip}
                            key={`${term.year}-${term.semester}-${i}`}
                            data-color='primary'
                            selected={selectedTerm ? compareTerms(term, selectedTerm) === 0 : false}
                            asChild
                        >
                            <button onClick={() => onSelectTerm(term)}>
                                {t(`cart:${term.semester.toLowerCase()}`, { year: term.year })}
                            </button>
                        </Chip>
                    ))}

                {loadFilters.length > 1 &&
                    loadFilters.map((value, i) => (
                        <Chip
                            startIcon={
                                value === 'FullTime' ? (
                                    <EllipseFilledIcon aria-hidden='true' />
                                ) : (
                                    <EllipseHalfIcon aria-hidden='true' />
                                )
                            }
                            className={styles.filterChip}
                            key={`${value}-${i}`}
                            data-color='primary'
                            selected={value === selectedLoad}
                            asChild
                        >
                            <button onClick={() => onSelectLoad(value)}>{t(`cart:load:${value}`)}</button>
                        </Chip>
                    ))}
            </div>
        </div>
    );
}
